export default "__VITE_ASSET__CVyl9V_B__"